<template>
  <div class="flex">
    <span v-for="(d, i) in 5" :key="i" class='margin-right-2'>
      <Star v-if="i < data" :classStr="{ 'text-yellow-medium': i < data }" />
      <StarOutlined v-else :classStr="'text-yellow-medium'" />
    </span>
  </div>
</template>

<script>
import { Star, StarOutlined } from "@/components/icons";

export default {
  components: {
    Star,
    StarOutlined,
  },
  props: ["data"],
  data() {
    return {};
  },
};
</script>
<style >
.margin-right-2{
  margin-right:2px;
}
</style>
